export default __webpack_public_path__ + "static/media/manufacturing2.8f1e0feb.svg";